export default __webpack_public_path__ + "static/media/tweeter-small.1dee2d06.svg";